import { TreeNode } from '../route-builder';

export const LogoutModule = { segment: 'logout' } as const satisfies TreeNode;
